<template>
  <page-outline :title="$t('Webheader.history')">
    <template slot="pageContent">
    <!-- <div class="layoutTop"></div> -->
      <div class="listPage">
        <b-row>
          <b-col>
            <div class="requestsList">
              <f7-list class="mb-2">
                <f7-list-item :class="additionalClass">
                  <b-row class="no-gutter justify-content-start">
                    <!-- Left section filtre -->
                    <div>
                      <b-button class="btn btnFilter btn-secondary"
                        :aria-label="$t('common.rfrsh')"
                        @click="refreshInbox()">
                        <i class="fa fa-rotate-right"></i>
                      </b-button>
                    </div>
                    <!-- Right section filtre -->
                    <!-- <b-button class="btn btnFilter_2 ml-2"
                      @click="exportList()">
                      <i class="fa-light fa-upload"></i>
                      <span class="fab-label">{{ $t('common.extract_list') }}</span>
                    </b-button> -->
                    <!-- TLV 15/01/2021 - Button for showing the filter on small screens more clearly -->
                    <div>
                      <b-button class="btnFilter_2 form-group mx-3"
                        @click="extractCSV()">
                        <i class="fa-light fa-upload fs-14px"></i>
                        <span class="fab-label">{{ $t('common.extract_list') }}</span>
                      </b-button>
                    </div>
                  </b-row>
                </f7-list-item>

                <f7-list-item class="filter-item-section showLargeScreenOnly" :key="keyFiltres" v-if="allCountries">
                  <b-col cols="8" class="d-flex row justify-content-start p-0">
                    <div class="filter-item col-4">
                      <label
                          for="filter-user-active"
                          class="filter-item-title">
                        {{ $t('administration.country') }}
                      </label>
                      <span class="filter-item-content">
                        <select
                          id="filter-user-active"
                          ref="selectDoctype"
                          v-model="countrySelected"
                          @change="delayApplyFilter"
                          autocomplete="off"
                          class="pt-2 cursor fs-14px-important h-auto z-2">
                          <option value="">
                            {{ $t('common.all') }}
                          </option>
                          <option v-for="(country, idCountry) in countries" :key="'history-filter-country-' + idCountry" :value="idCountry">{{ country.name }}</option>
                        </select>
                        <i
                          class="fa-light fa-chevron-down p-1 float-right mt--22px-important z-1"
                          aria-hidden="true">
                        </i>
                      </span>
                    </div>
                  </b-col>
                </f7-list-item>

                    <!-- Sélection des valeurs de Filtre -->
                <f7-list-item class="filter-item-section showLargeScreenOnly" :key="keyFiltres">
                  <b-row class="min-w-100">
                    <b-col class="d-flex flex-row">
                      <!-- Filtre date de début -->
                      <div class="filter-item" >
                        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
                          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin, 'error-datepicker': dateBeginError}"
                          customInputParentClass="filter-item-content"
                          :maxLength="19"
                          :placeholderValue="$t('common.datetime_picker_empty_date')"
                          inputIcon="fa-solid fa-calendar"
                          v-model="dateBegin"
                          :inputLabel="$t('common.date_start_label')"
                          @input="delayApplyFilter">
                        </datetime-picker-custom>
                        <span v-if="dateBeginError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
                      </div>
                      <!-- Filtre date de fin -->
                      <div class="filter-item" >
                        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
                          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd, 'error-datepicker': dateEndError}"
                          customInputParentClass="filter-item-content"
                          customInputClass="w-100"
                          :maxLength="19"
                          :placeholderValue="$t('common.datetime_picker_empty_date')"
                          inputIcon="fa-solid fa-calendar"
                          v-model="dateEnd"
                          :inputLabel="$t('common.date_end_label')"
                          @input="delayApplyFilter">
                        </datetime-picker-custom>
                        <span v-if="dateEndError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
                      </div>
                      <!--Filtre actionType -->
                      <div class="filter-item">
                        <span class="filter-item-title text-ellipsis">
                          {{ $t('common.action_type') }}
                        </span>
                        <a :id="'action-type-picker-link-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                          href="#">
                          <span :class="'fixed-span-size ' + (actionTypeDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ actionTypeDisplay.label }}</span>
                          <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
                        </a>
                        <b-popover :target="'action-type-picker-link-' + randomString"
                          :title="$t('filter.selected_type_none')"
                          triggers="focus" placement="bottom">
                          <div>
                            <span key="allActionTypes">
                              <b-form-checkbox v-model="allActionType"
                                @change="checkAll"
                                :value="true"
                                :unchecked-value="false">
                                <span class="font-weight-normal fs-13px">{{ allActionType ? $t('filter.all_uncheck') : $t('filter.all_check') }}</span>
                              </b-form-checkbox>
                            </span>
                          </div>
                          <hr class="my-2 mx-m08">
                          <!-- Action types by Category (or family) -->
                          <div v-for="(categoryStatus, categoryName) in actionTypeCategories" :key="'action-type-category-' + categoryName">
                            <span class="MoneyRoadcolorBlack">{{ $t('history.action_type_categories.' + categoryName) }}</span>
                            <span v-for="(actionType, index) in actionTypeList" :key="'action-type-' + actionType.id + '-' + index">
                              <b-form-checkbox v-model="actionType.state" v-if="categoryStatus.includes(actionType.id)"
                                @input="actionTypeChange"
                                :value="1"
                                :unchecked-value="0">
                                <span class="font-weight-normal fs-13px">{{ actionType.label }}</span>
                              </b-form-checkbox>
                            </span>
                          </div>
                        </b-popover>
                      </div>

                      <!-- Filtre user login -->
                      <div class="filter-item">
                        <label class="filter-item-title" for="login-filter">
                          {{ $t('administration.login') }}
                        </label>
                        <span class="filter-item-content">
                          <input v-model="login" @input="delayApplyFilter"
                            autocomplete="off"
                            id="login-filter"
                            type="text"
                            :class="{'filter-item-input': true, 'filter-item-input-complete': login}"
                            :placeholder="$t('administration.login')">
                        </span>
                      </div>
                      <!-- Filtre user name -->
                      <div class="filter-item">
                          <label class="filter-item-title" for="user-filter">
                            {{ $t('common.user') }}
                          </label>
                        <span class="filter-item-content">
                          <input v-model="user" @input="delayApplyFilter"
                            autocomplete="off"
                            id="user-filter"
                            type="text"
                            :class="{'filter-item-input': true, 'filter-item-input-complete': user}"
                            :placeholder="$t('common.user')">
                        </span>
                      </div>
                    </b-col>
                    <!-- Bouton Effacer et Appliquer -->
                    <b-col cols="3" class="d-flex mt-4">
                      <b-button class="btn mr-2" size="sm"
                        @click="clearFilterFields"
                        :disabled="!hasInputFilter">
                        {{ $t('filter.clr_fltr_field') }}
                      </b-button>
                      <b-button class="btn" size="sm"
                        @click="applyFilter">
                        {{ $t('filter.fltr') }}
                      </b-button>
                    </b-col>
                  </b-row>
                </f7-list-item>
              </f7-list>

              <spinner v-if="activateSpinner"></spinner>
              <div v-else>
                <span v-if="inboxMessages.length" class="font-weight-bold">{{ $t('common.results_actions_desc') +  paginationObject.nbResultsTotal}}</span>
                <b-table hover borderless outlined class="table mt-3 text-center table-striped"
                  v-if="inboxMessages.length"
                  :items="inboxMessages"
                  :fields="historyFields"
                  :key="resetHisto">
                  <template #cell(dateAction)="data"><div class="cursor text-ellipsis"><span>{{data.value | formatDateTime}}</span></div></template>
                  <template #cell(name)="data">
                    <div v-if="!data.value">-</div>
                    <div v-else>{{ data.value }}</div>
                  </template>
                  <template #cell(idCountry)="data">
                    {{ getCountryName(data.value) }}
                  </template>
                  <template #cell(label)="data">
                    <span v-if="!translateDetails(data.item.details, data.item).length">{{addActionCategory(data.item)}}{{data.value}}</span>
                    <f7-accordion-item v-else class="accordionForm"
                      :expanded="data.item.open"
                      @accordion:open="data.item.open=true"
                      @accordion:opened="data.item.openFinished=true;resetHisto = !resetHisto"
                      @accordion:close="data.item.open=data.item.open=false"
                      @accordion:closed="data.item.openFinished=false;resetHisto = !resetHisto">
                      <f7-accordion-toggle class="accordionToggle">
                        <div class="form-group row justify-content-center">
                          <div class="col-sm-auto">
                            {{addActionCategory(data.item)}}{{ data.value }}
                            <i class="ml-1 mt-1 fa-light fa-chevron-down color-var-actionButtonColorBlue"
                              v-if="data.item.open === true">
                            </i>
                            <i class="ml-1 fa-light fa-chevron-right color-var-actionButtonColorBlue"
                              v-else>
                            </i>
                          </div>
                        </div>
                      </f7-accordion-toggle>
                      <f7-accordion-content :class="{accordionContentExpended: data.item.openFinished}">
                        <div v-for="(detail,index) in translateDetails(data.item.details, data.item)" :key="'history-detail-' + data.item.idActionHistory + '-' + index">
                          <span v-if="isRTPAction(data.item)" class="cursor" @click="detailsRTP(data.item)"><u>
                            {{ $t('history.rtp_details') }}</u>
                          </span>
                          <span v-else-if="isAPICall(data.item)">
                            <spinner v-if="data.item.spinner"></spinner>
                            <span v-else-if="detail.name === 'Response'"><b>{{detail.name}}</b>&nbsp;{{$t('common.see_json')}}<i class="fa fa-eye cursor px-2 color-var-actionButtonColorBlue" @click="seeXml(detail.value)"></i></span>
                            <span v-else-if="detail.name === 'MoreId'" class="cursor" @click="getAPIDetails(data.item)">{{$t('history.click_more_info_api')}}</span>
                            <span v-else><b>{{detail.name}}</b>&nbsp;{{detail.value}}</span>
                          </span>
                          <span v-else>
                            <span><b>{{translateDetailsPrint(data.item.typeAction, 'name', detail)}} </b></span>
                            <span v-if="detail.old !== undefined">{{detail.old ? detail.old : '-'}}&nbsp;<b>→</b>&nbsp;</span>
                            <span v-if="['dateBegin','dateEnd'].includes(detail.name)">{{ detail.value | formatDateTime }}</span>
                            <span v-else>{{translateDetailsPrint(data.item.typeAction, 'value', detail)}}</span>
                          </span>
                        </div>
                      </f7-accordion-content>
                    </f7-accordion-item>
                  </template>
                </b-table>
                <div class="d-flex justify-content-center mt-5" v-else><b>{{ $t('common.no_result')}}</b></div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="!activateSpinner" class="mt-1">
          <b-col cols="12">
            <cm-pagination :maxResultsByPage="paginationObject.maxResults" :firstIndex="paginationObject.firstIndex" :nbResultsTotal="paginationObject.nbResultsTotal" :refreshEvent="paginationObject.refresh"></cm-pagination>
          </b-col>
        </b-row>
      </div>
  <!-- </f7-page> -->
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

import dateTimePicker from '@/components/common/dateTimePicker.vue'
// import MessagesFilter from '@/components/common/Filter'
// import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'

import { downloadFileWithDefinedHeaders } from '@/helpers/download'
import { errorMessageAlert } from '@/helpers/alert'
import { formatDateTime } from '@/helpers/format'
import { loadPage } from '@/helpers/routing'

export default {
  name: 'HistoryPage',
  components: {
    // 'cm-messages-filter': MessagesFilter,
    'cm-pagination': Pagination,
    'datetime-picker-custom': dateTimePicker,
    // 'form-write-group-label-input': formWriteGroupLabelInput,
    'spinner': Spinner,
    'page-outline': PageOutline
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    }
  },
  data () {
    return {
      actionTypeCategories: {
        Auth: ['1','22','2'],
        RTP: ['9','10','11','12','23','24'],
        Users: ['13','14','15'],
        Administration: ['16','17','18','19','20','21','25','26','27','28','29']
      },
      actionTypeList: {
        Auth: {
          label: this.$i18n.t('history.action_type.1'),
          id: '1',
          state: 1,
        },
        LoginSSO: {
          label: this.$i18n.t('history.action_type.22'),
          id: '22',
          state: 1,
        },
        ChangePassword: {
          label: this.$i18n.t('history.action_type.2'),
          id: '2',
          state: 1,
        },
        RTPCreate: {
          label: this.$i18n.t('history.action_type.9'),
          id: '9',
          state: 1,
        },
        RTPCancel: {
          label: this.$i18n.t('history.action_type.10'),
          id: '10',
          state: 1,
        },
        RTPAnswer: {
          label: this.$i18n.t('history.action_type.11'),
          id: '11',
          state: 1,
        },
        RTPPay: {
          label: this.$i18n.t('history.action_type.12'),
          id: '12',
          state: 1,
        },
        UserCreate: {
          label: this.$i18n.t('history.action_type.13'),
          id: '13',
          state: 1,
        },
        UserEdit: {
          label: this.$i18n.t('history.action_type.14'),
          id: '14',
          state: 1,
        },
        UserDelete: {
          label: this.$i18n.t('history.action_type.15'),
          id: '15',
          state: 1,
        },
        WebServiceConfig: {
          label: this.$i18n.t('history.action_type.16'),
          id: '16',
          state: 1,
        },
        KafkaConfig: {
          label: this.$i18n.t('history.action_type.17'),
          id: '17',
          state: 1,
        },
        SecurityConfig: {
          label: this.$i18n.t('history.action_type.18'),
          id: '18',
          state: 1,
        },
        RTPGlobalSettings: {
          label: this.$i18n.t('history.action_type.19'),
          id: '19',
          state: 1,
        },
        ClearingBICs: {
          label: this.$i18n.t('history.action_type.20'),
          id: '20',
          state: 1,
        },
        APICalls: {
          label: this.$i18n.t('history.action_type.21'),
          id: '21',
          state: 1,
        },
        BackOfficeExtract: {
          label: this.$i18n.t('history.action_type.23'),
          id: '23',
          state: 1,
        },
        OrphansExtract: {
          label: this.$i18n.t('history.action_type.24'),
          id: '24',
          state: 1,
        },
        HistoryExtract: {
          label: this.$i18n.t('history.action_type.25'),
          id: '25',
          state: 1,
        },
        TPPClientCreate: {
          label: this.$i18n.t('history.action_type.26'),
          id: '26',
          state: 1,
        },
        TPPClientEdit: {
          label: this.$i18n.t('history.action_type.27'),
          id: '27',
          state: 1,
        },
        TPPClientDelete: {
          label: this.$i18n.t('history.action_type.28'),
          id: '28',
          state: 1,
        },
        Country: {
          label: this.$i18n.t('history.action_type.29'),
          id: '29',
          state: 1,
        },
      },
      activateSpinner: false,
      allActionType: true,
      countries: this.$engine.rights.getCountries(),
      countrySelected: '',
      currentIndex: 1,
      filterBy: '',
      dateBegin: '',
      dateBeginError: false,
      dateEnd: '',
      dateEndError: false,
      keyFiltres: false,
      login: '',
      name: '',
      inboxMessages: [],
      completeList: [],
      mode: 1,
      noMore: false,
      normId: '',
      normList: [{
          id: 1,
          label: this.$i18n.t('common.norm.srtp')
        },
        {
          id: 2,
          label: this.$i18n.t('common.norm.giro')
        },
        {
          id: 3,
          label: this.$i18n.t('common.norm.psd2')
        }
      ],
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      randomString: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5),
      requestsNumber: '',
      scrollFlag: true,
      serviceId : this.$engine.user.currentService.id.toString(),
      sortDirection: 'DESC',
      sortField: 'dateAction',
      displayFilter: false,
      hasDefaultFilter: false,
      reload: false,
      resetHisto: false,
      timer: '',
      user: ''
    }
  },
  computed: {
    actionTypeDisplay () {
      let realActionTypeList = this.realActionTypeList.filter(status => status.state === 1)
      if (realActionTypeList.length === 0) {
        return {
          label: this.$t('filter.selected_status_none'),
          nb: 0
        }
      } else if (realActionTypeList.length === 1) {
        return {
          label: this.serviceId === '1' ? this.$t('history.action_type.' + realActionTypeList[0].id) : realActionTypeList[0].label,
          icon: realActionTypeList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_type_many', {nbTypeAction: realActionTypeList.length}),
          nb: realActionTypeList.length
        }
      }
    },
    allCountries () {
      return !this.$engine.rights.getCurrentCountry().idCountry
    },
    appLanguage () {
      return this.$i18n.locale
    },
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    canSeeNormList () {
      return this.$engine.rights.rightIs('super_admin', true)
    },
    hasAdminHistoryConsulter() {
      return this.$engine.rights.rightIs('history_consulter_admin', true)
    },
    historyFields () {
      let fields = [
        { key: 'dateAction', label: this.$t('common.date_label'), class: 'text-center col-3' },
        { key: 'login', label: this.$t('administration.login'), class: 'text-center col-3'},
        { key: 'name', label: this.$t('common.usr'), class: 'text-center col-3' },
      ]
      if (this.allCountries) {
        fields.push({ key: 'idCountry', label: this.$t('common.ctry'), class: 'text-center col-3' })
      }
      fields.push({ key: 'label', label: this.$t('common.action_label'), class: 'text-center col-3' })
      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    hasInputFilter () {
      if (
        this.dateBegin ||
        this.dateEnd ||
        this.normId ||
        this.endToEndId ||
        this.login ||
        this.user ||
        !this.allActionType) {
        return true
      }
      return false
    },
    normDisplay () {
      let realNormList = this.realNormList.filter(norm => norm.state === 1)
      if (realNormList.length === 0) {
        return {
          label: this.$t('filter.selected_standard_none'),
          nb: 0
        }
      } else if (realNormList.length === 1) {
        return {
          label: realNormList[0].label,
          icon: realNormList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_standard_many', {nbNorm: realNormList.length}),
          nb: realNormList.length
        }
      }
    },
    realNormList () {
      let that = this
      const list = []
      for (const property in that.normList) {
        const norm = that.normList[property]
        list.push({
          tag: property,
          label: norm.label,
          state: norm.state,
          id: norm.id
        })
      }
      return list
    },
    realActionTypeList () {
      let that = this
      const list = []
      for (const property in that.actionTypeList) {
        const actionType = that.actionTypeList[property]
        list.push({
          tag: property,
          label: actionType.label,
          state: actionType.state,
          id: actionType.id
        })
      }
      return list
    }
  },
  watch:  {
    appLanguage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.actionTypeList = {
          Auth: {
            label: this.$i18n.t('history.action_type.1'),
            id: '1',
            state: 1,
          },
          LoginSSO: {
            label: this.$i18n.t('history.action_type.22'),
            id: '22',
            state: 1,
          },
          ChangePassword: {
            label: this.$i18n.t('history.action_type.2'),
            id: '2',
            state: 1,
          },
          RTPCreate: {
            label: this.$i18n.t('history.action_type.9'),
            id: '9',
            state: 1,
          },
          RTPCancel: {
            label: this.$i18n.t('history.action_type.10'),
            id: '10',
            state: 1,
          },
          RTPAnswer: {
            label: this.$i18n.t('history.action_type.11'),
            id: '11',
            state: 1,
          },
          RTPPay: {
            label: this.$i18n.t('history.action_type.12'),
            id: '12',
            state: 1,
          },
          UserCreate: {
            label: this.$i18n.t('history.action_type.13'),
            id: '13',
            state: 1,
          },
          UserEdit: {
            label: this.$i18n.t('history.action_type.14'),
            id: '14',
            state: 1,
          },
          UserDelete: {
            label: this.$i18n.t('history.action_type.15'),
            id: '15',
            state: 1,
          },
          WebServiceConfig: {
            label: this.$i18n.t('history.action_type.16'),
            id: '16',
            state: 1,
          },
          KafkaConfig: {
            label: this.$i18n.t('history.action_type.17'),
            id: '17',
            state: 1,
          },
          SecurityConfig: {
            label: this.$i18n.t('history.action_type.18'),
            id: '18',
            state: 1,
          },
          RTPGlobalSettings: {
            label: this.$i18n.t('history.action_type.19'),
            id: '19',
            state: 1,
          },
          ClearingBICs: {
            label: this.$i18n.t('history.action_type.20'),
            id: '20',
            state: 1,
          },
          APICalls: {
            label: this.$i18n.t('history.action_type.21'),
            id: '21',
            state: 1,
          },
          BackOfficeExtract: {
            label: this.$i18n.t('history.action_type.23'),
            id: '23',
            state: 1,
          },
          OrphansExtract: {
            label: this.$i18n.t('history.action_type.24'),
            id: '24',
            state: 1,
          },
          HistoryExtract: {
            label: this.$i18n.t('history.action_type.25'),
            id: '25',
            state: 1,
          },
          TPPClientCreate: {
            label: this.$i18n.t('history.action_type.26'),
            id: '26',
            state: 1,
          },
          TPPClientEdit: {
            label: this.$i18n.t('history.action_type.27'),
            id: '27',
            state: 1,
          },
          TPPClientDelete: {
            label: this.$i18n.t('history.action_type.28'),
            id: '28',
            state: 1,
          },
          Country: {
            label: this.$i18n.t('history.action_type.29'),
            id: '29',
            state: 1,
          },
        }
        this.keyFiltres = !this.keyFiltres
        this.onRefresh(false, this.currentIndex)
      }
    },
    actionTypeList: {
      deep: true,
      handler () {
        this.communicateChange()
      }
    }
  },
  created () {
    this.reload = false
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Historique',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0

    this.mode = parseInt(this.modeFilter, 10)
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'history-page'
    this.$bus.$off('history-page')
    this.$bus.$on('history-page', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    // this.filterTypeGet = this.filterType
    // this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.history.cleanFilterCondition()
  },
  methods: {
    actionTypeChange () {
      let nbChecked = 0
      for (const category in this.actionTypeList) {
        if (this.actionTypeList[category].state) {
          nbChecked++
        }
      }
      this.allActionType = Object.keys(this.actionTypeList).length === nbChecked
      this.delayApplyFilter()
    },
    addActionCategory (item) {
      let message = ''
      for (const category in this.actionTypeCategories) {
        if (this.actionTypeCategories[category].includes(item.typeAction)) {
          message = this.$t('history.action_type_categories.' + category) + ' - '
        }
      }
      return message
    },
    applyFilter () {
      let filterConditions = {}
      clearTimeout(this.timer)
      this.reload = true
      this.dateBeginError = this.dateBegin && !formatDateTime(this.dateBegin)
      this.dateEndError = this.dateEnd && !formatDateTime(this.dateEnd)
      if (this.dateBeginError || this.dateEndError) {
        return
      }
      filterConditions.idCountry = this.countrySelected
      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.login = this.login
      filterConditions.name = this.user
      filterConditions.typeAction = this.realActionTypeList.filter(elem => elem.state === 1).map(elem => elem.id).join(',')
      if (filterConditions.typeAction.split(',').length === Object.keys(this.actionTypeList).length) {
        // filterConditions.typeAction = ''
      }
      filterConditions.lang = this.$i18n.locale.toUpperCase()
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      let that = this
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = 'DESC' //this.sortDirection

      filterConditions.Norm = this.$engine.rights.rightIs('super_admin', true) ? this.normId : this.$engine.user.getUserNorm()

      this.activateSpinner = true
      if (!filterConditions.typeAction) {
        that.updateInbox([])
        this.activateSpinner = false
        return
      }
      this.$engine.history.update(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults //actionHistory.length
        that.paginationObject.nbResults = resp.data.actionHistory.length
        requests = resp.data.actionHistory
        // requests = requests.slice(that.paginationObject.firstIndex - 1, that.paginationObject.firstIndex - 1 + that.paginationObject.maxResults)
        that.updateInbox(requests)
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    checkAll () {
      for (const category in this.actionTypeList) {
        this.actionTypeList[category].state = this.allActionType ? 1 : 0
      }
    },
    delayApplyFilter() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.applyFilter()
      }, 1500)
    },
    detailsRTP (item) {
      let that = this
      if (this.isJSON(item.details)) {
        let parsed = JSON.parse(item.details)
        let param = parsed[0].name
        if (param === 'MsgId') {
          // aller chercher l'IdRequest puis redirect
          this.$engine.services.payments.updateBack('1', 1, 1, {msgId: parsed[0].value})
          .then(resp => {
            if (resp && resp.data && resp.data.payments && resp.data.payments.length) {
              let linkedRTP = resp.data.payments[0]
              let idRequest = linkedRTP.id
              this.$engine.services.payments.idRequest = idRequest
              this.$bus.$emit('switch-selected-menu', '/rtp/listBack/2/1/0')
              loadPage(this, {url: '/payments/transaction-details/' + idRequest})
            }
          })
          .catch(err => {
            errorMessageAlert(err, that)
          })
        } else {
          let idRequest = parsed[0].value
          this.$engine.services.payments.idRequest = idRequest
          this.$bus.$emit('switch-selected-menu', '/rtp/listBack/2/1/0')
          loadPage(this, {url: '/payments/transaction-details/' + idRequest})
        }
      }
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      let that = this
      this.dateBegin = ''
      this.dateEnd = ''
      this.endToEndId = ''
      this.normId = ''
      this.login = ''
      this.user = ''
      this.allActionType = true
      for (let property in that.actionTypeList) {
        that.actionTypeList[property].state = 1
      }

      this.communicateChange()
      this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    extractCSV () {
      let firstLine = ''
      firstLine =
        this.$t('common.date_label') + ';' +
        this.$t('administration.company') + ';' +
        this.$t('common.usr') + ';' +
        this.$t('common.action_label') +
        ' \r\n'

      let lines = ''
      let that = this

      // this.scrollFlag = true
      let filterConditions = {}
      //this.reload = true

      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.login = this.login
      filterConditions.name = this.user
      filterConditions.typeAction = this.realActionTypeList.filter(elem => elem.state === 1).map(elem => elem.id).join(',')
      filterConditions.lang = this.$i18n.locale.toUpperCase()

      if (filterConditions.typeAction.split(',').length === Object.keys(this.actionTypeList).length) {
        // filterConditions.typeAction = ''
      }

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = 'DESC' //this.sortDirection

      filterConditions.Norm = this.$engine.rights.rightIs('super_admin', true) ? this.normId : this.$engine.user.getUserNorm()

      if (!filterConditions.typeAction) {
        let data = firstLine
        that.$f7.hidePreloader()
        // const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let encodedData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        let linkSource = URL.createObjectURL(encodedData);
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.$t('Webheader.history') + '_' + today.unix() + '.csv'
        if (
        this.$f7.device.os === 'android' ||
        this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
        return
      }

      this.$engine.history.update(
        this.direction,
        undefined,
        undefined,
        filterConditions
      ).then(resp => {
        let historyMessagesCSV = {}
        historyMessagesCSV = resp.data.actionHistory

        let format = 'YYYY-MM-DD HH:mm:ss'
        for (let datas in historyMessagesCSV) {
          let actionDate = historyMessagesCSV[datas].dateAction ? moment(historyMessagesCSV[datas].dateAction, 'YYYY-MM-DDTHH:mm:ss').format(format) : '-'
          let company = historyMessagesCSV[datas].account ? historyMessagesCSV[datas].account : '-'
          let login = historyMessagesCSV[datas].login ? historyMessagesCSV[datas].login : '-'
          let user = historyMessagesCSV[datas].name ? historyMessagesCSV[datas].name : '-'
          let action = historyMessagesCSV[datas].label ? historyMessagesCSV[datas].label : '-'

          lines += actionDate + ';' +
          company + ';' +
          login + ';' +
          user + ';' +
          action + ';' +
          '\r\n'
        }

        let data = firstLine + lines
        that.$f7.hidePreloader()
        // const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let encodedData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        let linkSource = URL.createObjectURL(encodedData);
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.$t('Webheader.history') + '_' + today.unix() + '.csv'
        if (
        this.$f7.device.os === 'android' ||
        this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        if (error && error.response && error.response.data && error.response.data.error && error.response.data.error === 'ERR20') {
          that.$f7.alert(that.$i18n.t('errors._specific.description.ERR20', {nb: error.response.data.errorDescription}), that.$i18n.t('errors._specific.title.ERR20'))
        } else {
          errorMessageAlert(error, that)
        }
      })
    },
    exportList () {
      // mettre en place mode CSV coté modé
      let that = this
      let filterConditions = {}

      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.login = this.login
      filterConditions.name = this.user
      filterConditions.typeAction = this.realActionTypeList.filter(elem => elem.state === 1).map(elem => elem.id).join(',')
      if (filterConditions.typeAction.split(',').length === Object.keys(this.actionTypeList).length) {
        filterConditions.typeAction = ''
      }

      filterConditions.Norm = this.$engine.user.getUserNorm()

      this.$engine.history.getExport(
        filterConditions
      ).then( resp => {
        let list = {}
        list = resp.data.ExportActionHistory
        that.updateList(list)
        that.exportHistory()
      }).catch(e => {
        errorMessageAlert(e, that)
      })
    },
    exportHistory () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = 'Date' + ';' +
        'Type d\'action' + ';' +
        'Utilisateur' + ';' +
        'Identifiant' + ';' +
        'Détails' + '\r\n'

      let line = atob(this.completeList.result)
      let data = firstLine + line
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'history_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    getAPIDetails (data) {
      this.inboxMessages = _.cloneDeep(this.inboxMessages)
      let that = this
      if (data.details && this.isJSON(data.details) && JSON.parse(data.details)[0].value) {
        let id = JSON.parse(data.details)[0].value
        this.$engine.history.update(
          this.direction,
          1,
          1,
          {
            idActionHistory: id,
            normId: this.normId
          }
        ).then(resp => {
          if (resp && resp.data && resp.data.actionHistory && resp.data.actionHistory.length) {
            that.inboxMessages.forEach((item, i) => {
              if (item.idActionHistory === id) {
                resp.data.actionHistory[0].open = that.inboxMessages[i].open
                resp.data.actionHistory[0].openFinished = that.inboxMessages[i].openFinished
                that.inboxMessages[i] = resp.data.actionHistory[0]
              }
            })
            that.inboxMessages = _.cloneDeep(that.inboxMessages)
          }
        })
        .catch(err => {
          that.activateSpinner = false
          that.inboxMessages = _.cloneDeep(that.inboxMessages)
          errorMessageAlert(err, that)
        })
      }
    },
    getCountryName (idCountry) {
      let country = this.countries[idCountry]
      return country ? country.name : '-'
    },
    isAPICall (item) {
      return item.typeAction === '21'
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    isRTPAction (item) {
      if (this.isJSON(item.details) && ['9','10','11','12'].includes(item.typeAction)) {
        let currentNorm = this.$engine.rights.rightIs('super_admin', true) ? '0' : this.$engine.user.getUserNorm()
        if (currentNorm === '1') {
          return this.$engine.rights.rightIs('rtp_backoffice_consulter_srtp', true)
        } else if (currentNorm === '2') {
          return this.$engine.rights.rightIs('rtp_backoffice_consulter_hrtp', true)
        } else if (currentNorm === '3') {
          return this.$engine.rights.rightIs('rtp_backoffice_consulter_psd2', true)
        } else if (currentNorm === '0') {
          return this.$engine.rights.rightIs('rtp_backoffice_consulter', true)
        }
        return false
      }
      return false
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      // let that = this
      let that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.currentIndex = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {}

      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.login = this.login
      filterConditions.name = this.user
      filterConditions.typeAction = this.realActionTypeList.filter(elem => elem.state === 1).map(elem => elem.id).join(',')
      if (filterConditions.typeAction.split(',').length === Object.keys(this.actionTypeList).length) {
        // filterConditions.typeAction = ''
      }

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      filterConditions.lang = this.$i18n.locale.toUpperCase()

      filterConditions.Norm = this.$engine.rights.rightIs('super_admin', true) ? this.normId : this.$engine.user.getUserNorm()

      if ([...new Set(filterConditions.typeAction.split(','))].length === 4) {
        // filterConditions.typeAction = ''
      }

      if (!filterConditions.typeAction) {
        that.updateInbox([], noAttach)
        this.activateSpinner = false
        return
      }

      this.$engine.history.update(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = []
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.actionHistory.length
        requests = resp.data.actionHistory
        that.updateInbox(requests, noAttach)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    onSearch (query) {
      this.filterBy = query
    },
    refreshInbox () {
      this.reload = true
      this.onRefresh(false, this.paginationObject['firstIndex'])
    },
    seeXml (xmlDetails) {
      this.$bus.emit('popup-xml-details', {type:'Bank Repository',data: 'data:text/plain;base64,' + xmlDetails})
    },
    translateDetails (details, item) {
      if (this.isJSON(details)) {
        let parsed = JSON.parse(details)
        if (['9','10','11','12'].includes(item.typeAction) && this.$engine.rights.rightIs('rtp_backoffice_consulter',false)) {
            return []
        }
        return parsed
      }
      return []
    },
    translateDetailsPrint (typeAction, field, detail) {
      let that = this
      if (field === 'name') {
        let tradName = 'history.details_name.'+detail[field]
        return this.$t(tradName) === tradName ? detail[field] : this.$t(tradName)
      }
      if (field === 'value') {
        if (typeAction === '23' && detail.name === 'status') {
          let tmp = detail.value.split(',')
          tmp.forEach((item, i) => { tmp[i] = that.$t('common.status.rtp.' + item) === 'common.status.rtp.' + item ? item : that.$t('common.status.rtp.' + item)})
          return tmp.join(', ')
        }
        if (typeAction === '24' && detail.name === 'messageType') {
          let tmp = detail.value.slice(1, -1).split(',')
          tmp.forEach((item, i) => { tmp[i] = that.$t('filter.orphan.message_type.' + item) === 'filter.orphan.message_type.' + item ? item : that.$t('filter.orphan.message_type.' + item)})
          return tmp.join(', ')
        }
        if (typeAction === '25' && detail.name === 'typeAction') {
          let tmp = detail.value.split(',')
          tmp.forEach((item, i) => { tmp[i] = that.$t('history.action_type.' + item) === 'history.action_type.' + item ? item : that.$t('history.action_type.' + item)})
          return tmp.join(', ')
        }
      }
      return detail[field] ? detail[field] : '-'
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateList (requests) {
      this.completeList = requests
    },
    showButtonImportLot () {
      // Service RTP import lot identifiant?
      return false
    }
  }
}
</script>
